"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultNode = exports.setDefaultNode = void 0;
var defaultNode = null;

var setDefaultNode = function setDefaultNode(node) {
  defaultNode = node;
};

exports.setDefaultNode = setDefaultNode;

var getDefaultNode = function getDefaultNode() {
  return defaultNode || document.body;
};

exports.getDefaultNode = getDefaultNode;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/utils/RootNode.js
// module id = 115
// module chunks = 0